<template>
  <div class="main">
    <div class="nav">
      <Nav title="科室列表" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="body_list">
      <div class="deptcell" v-for="(item, index) in deptlist" @click="godetail(item)">
        <div class="title">{{item.title}}</div>
        <div class="content_list">
          <div  class="content_text">
           <!-- {{item.content}} -->
           <div v-html="item.content" class="p_text_style"></div>
          </div>
          <div class="content_icon">
            <van-icon name="arrow" color="#747d8c" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import Nav from "@/components/nav.vue";
import list from "./components/list.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor';
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      deptlist:[],
      text:null,
    };
  },
  mounted(){
    this.init()
  },
 methods:{
   godetail(item){
      this.$router.push({
        path: "/deptlist_detail",
        query: {
          item,
        },
      });
   },
   async init() {
      //请求医院信息
      try {
        this.$showLoad();
        let url = "/introduceController/queryIntroduceListBytype";
        let R_data={
          type:"2"
        }
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          R_data,
          (data) => {
            console.log(data);
            this.deptlist = data.data;
            this.text=this.deptlist.content
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
 },
  components: {
    Nav,
    list,
  },
};
</script>

<style lang="scss" scoped>
  
.main {
  .nav {
    .top {
      height: 50px;
      width: 1px;
    }
  }
  .body_list {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: scroll;
    max-height: 100vh;
    .deptcell {
      display: flex;
      flex-direction: column;
      width: 95%;
      margin: 0px auto;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 8px;
      .title {
        color: #666;
        line-height: 40px;
        height: 40px;
        font-size: 18px;
        letter-spacing:4px
      }
      .content_list {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .content_text {
          font-size: 13px;
          //    overflow:hidden;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 30px;
          height: 60px;
          font-size: 16px;
          color: #999;
          letter-spacing:2px;
           margin-bottom: 4px;
        }
      
        .content_icon {
          display: flex;
          align-items:center;
          align-content: center;
        }
      }
    }
  }
}
</style>